// @flow
import ApiService from '@api/service';
import { API_PATHS } from '@app/constants/paths';

const { DATA_EXPORT_JOBS } = API_PATHS;

const POLL_INTERVAL_MS = 3000;
const POLL_MAX_ATTEMPTS = 40; // ~2 minutes

class KpiExportService {
  requestExport = async (): Promise<number> => {
    const response = await ApiService.request({
      method: 'post',
      url: DATA_EXPORT_JOBS,
      data: { exporter: 'kpi' },
    });
    return response.data.id;
  };

  pollUntilComplete = async (jobId: number): Promise<string> => {
    for (let attempt = 0; attempt < POLL_MAX_ATTEMPTS; attempt++) {
      const response = await ApiService.request({
        method: 'get',
        url: `${ DATA_EXPORT_JOBS }/${ jobId }`,
      });

      const { status, downloadUrl } = response.data;

      if (status === 'completed' && downloadUrl) {
        return downloadUrl;
      }

      if (status === 'failed') {
        throw new Error('export_failed');
      }

      await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
    }

    throw new Error('export_timeout');
  };
}

export default new KpiExportService();
